import { Button } from "antd";
import styled from "styled-components";

export const Title = styled.h3`
  text-align: center;
  margin-bottom: 1rem;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 2rem;
  margin-top: 1rem;
`;

export const SubmitButton = styled(Button).attrs({
  htmlType: "submit",
  type: "primary",
  shape: "round",
  size: "large",
})``;
